import type { Platform } from "./platform";

/**
 * The store badges of a static page: a phone sees its own store, a computer
 * both. `hrefFor` sets each link (a page that counts store taps sends them
 * through the API); null leaves them alone (the landing's badges carry
 * their own href).
 */
export function revealStoreBadges(
  root: ParentNode,
  platform: Platform,
  hrefFor: ((store: "ios" | "android") => string) | null,
): void {
  root.querySelectorAll<HTMLAnchorElement>("[data-store]").forEach((badge) => {
    const store = badge.dataset["store"];
    if (store !== "ios" && store !== "android") return;
    if (platform !== "desktop" && platform !== store) return;
    if (hrefFor !== null) badge.href = hrefFor(store);
    badge.hidden = false;
  });
  root.querySelectorAll<HTMLElement>("[data-apps]").forEach((apps) => {
    apps.hidden = false;
  });
}
